import React from "react";
import MainRouter from "./MainRouter";
import "./index.css";
import "./styles/partials/cane.scss";

const App = () => {
  return (
    <div>
        <MainRouter />
    </div>
  );
};
export default App;
